<!-- @format -->

<template>
	<div style="width: 100%">
		<disabled-text v-if="disabled && pcProps.showDisabledText" :value="value" :show-tag="true" />
		<el-input
			v-else
			:model-value="value"
			placeholder="请选择部门"
			:disabled="disabled"
			clearable
			suffix-icon="ArrowDown"
			@click="onShowUser()"
			@clear="() => onConfirm('confirm', {})"
		/>
		<pcp-org-selector
			:multiple="multiple"
			:visible="selectorVisible"
			@close="(visible) => (selectorVisible = visible)"
			@action-event="onConfirm"
		/>
	</div>
</template>

<script setup lang="ts">
	import { flat } from '../../utils/util';
	import { getCheckRowsToFormDatas } from '../../utils/user';
	import { getLinkList } from '../../config';
	import DisabledText from './disabledText.vue';
	import type { BasicField, FieldsType, WidgetConfigType } from '../../types';
	import type { Ref } from 'vue';
	import { PcpOrgSelector } from '@/p-components';

	interface Props {
		modelValue: string;
		pcProps: WidgetConfigType;
		multiple?: boolean;
		disabled?: boolean;
		item: BasicField;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
	});

	const emit = defineEmits(['update:modelValue']);

	const setFieldsValue = inject<(fields: Record<string, any>) => void>('setFieldsValue', () => {});
	const widgetDatas = inject<Ref<FieldsType[]>>('widgetDatas', ref([]));

	const selectorVisible = ref(false);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const flatWigetDatas = computed(() => flat(widgetDatas.value || []));

	const linkConfig = computed(() =>
		props.pcProps.linkConfig?.length
			? props.pcProps.linkConfig
			: [{ code: props.item.code, link: getLinkList(props.item?.type)[0].value }],
	);

	const onShowUser = () => {
		if (props.pcProps.isRequired !== '0') {
			selectorVisible.value = true;
		}
	};

	const onConfirm = (key, data) => {
		if (key == 'confirm') {
			//console.log(data);

			selectorVisible.value = false;
			const formDatas = getCheckRowsToFormDatas(linkConfig.value, flatWigetDatas.value, props.multiple ? data : [data]);

			setFieldsValue && setFieldsValue(formDatas);
		}
	};

	onMounted(() => {
		if (!props.modelValue && props.pcProps.isCurrentUser) {
			const { org } = window.pData.globalStore.userInfo;
			const formDatas = getCheckRowsToFormDatas(linkConfig.value, flatWigetDatas.value, [
				{
					name: (org && org.name) || '',
					id: (org && org.id) || '',
				},
			]);
			setFieldsValue && setFieldsValue(formDatas);
		}
	});
</script>

<style lang="scss" scoped></style>
